var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Profile__Page" }, [
    _c(
      "div",
      { staticClass: "Profile__Page__Menu" },
      [
        _c("h1", [_vm._v("אדמיניסטרציה")]),
        _c(
          "b-menu",
          [
            _c(
              "b-menu-list",
              [
                _c("b-menu-item", {
                  attrs: {
                    label: "פרופילים",
                    tag: "router-link",
                    to: "/admin/profiles"
                  }
                }),
                _c("b-menu-item", {
                  attrs: {
                    label: "ניהול דוחות",
                    tag: "router-link",
                    to: "/admin/search/reports"
                  }
                }),
                _c("b-menu-item", {
                  attrs: {
                    label: "דוחות לא מנוהלים",
                    tag: "router-link",
                    to: "/admin/search/unmanagedreports"
                  }
                }),
                _c("b-menu-item", {
                  attrs: {
                    label: "ניהול רכבים",
                    tag: "router-link",
                    to: "/admin/search/vehicles"
                  }
                }),
                _c("b-menu-item", {
                  attrs: {
                    label: "ניהול עיריות",
                    tag: "router-link",
                    to: "/admin/search/municipalities"
                  }
                }),
                _c(
                  "b-menu-item",
                  {
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function(props) {
                          return [
                            _vm._v(" ייבוא "),
                            _c("b-icon", {
                              staticClass: "is-pulled-left",
                              attrs: {
                                icon: props.expanded ? "menu-up" : "menu-down"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c("b-menu-item", {
                      attrs: {
                        label: "דוחות",
                        tag: "router-link",
                        to: "/admin/import/reports"
                      }
                    }),
                    _c("b-menu-item", {
                      attrs: {
                        label: "נהגים",
                        tag: "router-link",
                        to: "/admin/import/drivers"
                      }
                    }),
                    _c("b-menu-item", {
                      attrs: {
                        label: "רכבים",
                        tag: "router-link",
                        to: "/admin/import/vehicles"
                      }
                    }),
                    _c("b-menu-item", {
                      attrs: {
                        label: "רכבים עם בעלות בלבד",
                        tag: "router-link",
                        to: "/admin/import/vehicles/owned"
                      }
                    }),
                    _c("b-menu-item", {
                      attrs: {
                        label: "רכבים גרסה 2",
                        tag: "router-link",
                        to: "/admin/import/newvehicles"
                      }
                    }),
                    _c("b-menu-item", {
                      attrs: {
                        label: "רכבים גרסה 3",
                        tag: "router-link",
                        to: "/admin/import/newvehiclesv3"
                      }
                    }),
                    _c("b-menu-item", {
                      attrs: {
                        label: "משטרה",
                        tag: "router-link",
                        to: "/admin/import/police"
                      }
                    }),
                    _c("b-menu-item", {
                      attrs: {
                        label: "היסטוריית יבוא",
                        tag: "router-link",
                        to: "/admin/batchReports"
                      }
                    }),
                    _c("b-menu-item", {
                      attrs: {
                        label: "מרכז לגביית קנסות",
                        tag: "router-link",
                        to: "/admin/import/finecenter"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "b-menu-item",
                  {
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function(props) {
                          return [
                            _vm._v(" כלים "),
                            _c("b-icon", {
                              staticClass: "is-pulled-left",
                              attrs: {
                                icon: props.expanded ? "menu-up" : "menu-down"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c("b-menu-item", {
                      attrs: {
                        label: "יצירת קובץ לייבוא",
                        tag: "router-link",
                        to: "/admin/import/create"
                      }
                    }),
                    _c("b-menu-item", {
                      attrs: {
                        label: "סריקת נתוני מיקום",
                        tag: "router-link",
                        to: "/admin/import/locationdatascan"
                      }
                    }),
                    _c("b-menu-item", {
                      attrs: {
                        label: "סריקת נתוני דוחות",
                        tag: "router-link",
                        to: "/admin/crawlReports"
                      }
                    }),
                    _c("b-menu-item", {
                      attrs: {
                        label: "מחולל התראות",
                        tag: "router-link",
                        to: "/admin/import/generatealerts"
                      }
                    })
                  ],
                  1
                ),
                _c("b-menu-item", {
                  attrs: { tag: "router-link", to: "/admin/transfer-bots" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function() {
                        return [
                          _vm._v(" בוטי הסבות "),
                          _vm.botsHaveAlert
                            ? _c("b-icon", {
                                staticClass: "is-pulled-left",
                                attrs: {
                                  size: "is-small",
                                  type: "is-danger",
                                  icon: "alert-circle"
                                }
                              })
                            : _vm.botsReady
                            ? _c("b-icon", {
                                staticClass: "is-pulled-left",
                                attrs: {
                                  size: "is-small",
                                  type: "is-success",
                                  icon: "circle"
                                }
                              })
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _c(
                  "b-button",
                  {
                    staticClass: "terms-button",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.openTerms($event)
                      }
                    }
                  },
                  [_vm._v("קובץ נהלים בטר וואי")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "Profile__Page__Content" },
      [_vm.ready ? _c("router-view") : _vm._e()],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }